import { Record } from "../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, bool_type } from "../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value } from "../fable_modules/fable-library-js.4.19.0/Option.js";
import { int32ToString } from "../fable_modules/fable-library-js.4.19.0/Util.js";
import * as react from "react";
import { currentNotificationContext } from "../Context.fs.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.19.0/Seq.js";
import { ListProps, View as View_1 } from "./List.fs.js";

export class NotificationTriggerProps extends Record {
    constructor(RenderNotificationList) {
        super();
        this.RenderNotificationList = RenderNotificationList;
    }
}

export function NotificationTriggerProps_$reflection() {
    return record_type("Bfs.Web.Kundenportal.Notifications.Trigger.NotificationTriggerProps", [], NotificationTriggerProps, () => [["RenderNotificationList", bool_type]]);
}

export const View = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\Notifications\\Trigger.fs") + "#L") + int32ToString(value(13))) + ";") + "Bfs.Web.Kundenportal.Notifications.Trigger.NotificationTriggerProps", value("View"), (props) => {
    const notificationContext = react.useContext(currentNotificationContext);
    const dropDownOpen = notificationContext.ShowNotifications ? "is-active" : "";
    const bellIcon = notificationContext.HasUnreadNotifications ? "bell-unread" : "bell";
    const children_2 = toList(delay(() => append(singleton(react.createElement("a", {
        className: `dropdown-trigger is-relative ${bellIcon}`,
        onClick: (event) => {
            event.stopPropagation();
            notificationContext.ToggleShowNotifications();
        },
    })), delay(() => (props.RenderNotificationList ? singleton(View_1(new ListProps(true))) : empty())))));
    return react.createElement("div", {
        className: `notifications dropdown is-right ${dropDownOpen}`,
    }, ...children_2);
}, undefined, undefined, "Of");

//# sourceMappingURL=Trigger.fs.js.map
